import {
  addHoverEffect,
  getElementsByClassName,
  makeApiRequest,
  skeleton,
} from './utils';
import jsx from './jsx';

interface Game {
  link: string;
  title: string;
  console: string;
  image: string;
}

const createGameElement = (game: Game): Element => {
  const imageElement = (
    <div className="gameImage">
      <img
        src={game.image || '/placeholder.svg'}
        alt={game.title}
        style={!game.image ? 'object-fit: cover; width: 213px' : ''}
      />
    </div>
  ) as HTMLDivElement;

  addHoverEffect(imageElement);

  if (game.link) {
    return (
      <a
        href={game.link}
        target={
          game.link.includes('pfy.ch') ||
          game.link.includes('localhost') ||
          !game.link.includes('http')
            ? '_self'
            : '_blank'
        }
        className="game"
      >
        <div className="imageElementWrapper">{imageElement}</div>
        <div className="main">{game.title}</div>
        <p className="sub">{game.console}</p>
      </a>
    );
  } else {
    return (
      <div className="game">
        <div className="imageElementWrapper">{imageElement}</div>
        <div className="main">{game.title}</div>
        <p className="sub">{game.console}</p>
      </div>
    );
  }
};

const getLatestPlays = async () => {
  const renderTarget = getElementsByClassName('currentlyPlaying')?.[0];
  renderTarget?.append(skeleton('100%', '420px'));

  const json = await makeApiRequest<
    {
      gameId: string;
      title: string;
      consoleName: string;
      imageBoxArt: string;
    }[]
  >('/retroacheivements/recent', 'GET');

  if (renderTarget && json.length) {
    renderTarget.innerHTML = '';
    json.slice(0, 3).forEach((game) => {
      renderTarget.append(
        createGameElement({
          link: `https://retroachievements.org/game/${game.gameId}`,
          title: game.title,
          console: game.consoleName,
          image: `https://retroachievements.org/${game.imageBoxArt}`,
        }),
      );
    });
  }
};

document.addEventListener('DOMContentLoaded', async () => {
  const recommendations = getElementsByClassName('recommendations');

  recommendations?.forEach((recommendation) => {
    const table = recommendation.querySelector('table') as HTMLTableElement;

    if (table) {
      const data: Game[] = [...(table.querySelectorAll('tr') || [])]
        .map((row, index) => {
          if (index === 0) return;

          const cells = [...(row.children || [])] as HTMLTableCellElement[];
          return {
            title: cells[0].innerText,
            console: cells[1].innerText,
            link: cells[2].innerText,
            image: cells[3].innerText,
          };
        })
        .filter((game) => game) as Game[];

      const gameElements = data.map((game) => createGameElement(game));
      recommendation.innerHTML = '';
      recommendation.append(...gameElements);
    }
  });

  await getLatestPlays();
});
